import { useAuthContext } from '/src/hooks';

export function useAccountNumber() {
  const { currentAccount } = useAuthContext();

  const accountNumber = currentAccount?.paddedId ?? null;
  return [accountNumber];
}
